import { GlobalReducerActions } from "./globalReducer";
import axiosInstance from "services/axiosInstance";
import { setMembersOrderStr } from "util/helpers";
import Endpoints from "constants/Endpoints";
import Tables from "constants/Tables";

const { setLoading, setNotificationMessage, setCustomedNotificationMessage } = GlobalReducerActions;
const { SECTION, LIST_ITEM } = Endpoints;
const { ADVISORS_TABLE } = Tables;

const NEW_ADVISOR = {
  name: "",
  email: "",
  title_role: "",
  linkedin_url: "",
  twitter_url: "",
  image: "",
};

const ADVISORS_REDUCER_INITIAL_STATE = {
  retrievedData: false,
  data: [],
  selectedAdvisor: {},
  originalPositions: '',
  newPositions: '',
  newAdvisor: { ...NEW_ADVISOR },
};

export const ADVISORS_REDUCER_TYPES = {
  GET_ADVISORS_DATA: "GET_ADVISORS_DATA",
  SET_ADVISORS_DATA: "SET_ADVISORS_DATA",
  GET_SELECTED_ADVISOR_DATA: "GET_SELECTED_ADVISOR_DATA",
  SET_SELECTED_ADVISOR_DATA: "SET_SELECTED_ADVISOR_DATA",
  SET_ADVISORS_RETRIEVED_DATA: "SET_ADVISORS_RETRIEVED_DATA",
  SET_NEW_ADVISOR_DATA: "SET_NEW_ADVISOR_DATA",
  SET_ADVISORS_NEW_POSITIONS_DATA: "SET_ADVISORS_NEW_POSITIONS_DATA",
};

export const advisorsReducer = (
  state = ADVISORS_REDUCER_INITIAL_STATE,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case ADVISORS_REDUCER_TYPES.GET_ADVISORS_DATA:
      const updatedPayload = [...payload];
      updatedPayload.forEach(item => {
        if (!item.originalPosition) {
          item.originalPosition = item.position
        }
      });
      return {
        ...state,
        data: updatedPayload,
        originalPositions: setMembersOrderStr(updatedPayload, true),
        newPositions: setMembersOrderStr(updatedPayload, true)
      };
    case ADVISORS_REDUCER_TYPES.SET_ADVISORS_DATA:
      return {
        ...state,
        data: payload,
      };
    case ADVISORS_REDUCER_TYPES.SET_ADVISORS_NEW_POSITIONS_DATA:
      return {
        ...state,
        newPositions: payload,
      };
    case ADVISORS_REDUCER_TYPES.GET_SELECTED_ADVISOR_DATA:
      return {
        ...state,
        selectedAdvisor: payload,
      };
    case ADVISORS_REDUCER_TYPES.SET_SELECTED_ADVISOR_DATA:
      return {
        ...state,
        selectedAdvisor: payload,
      };
    case ADVISORS_REDUCER_TYPES.SET_NEW_ADVISOR_DATA:
      return {
        ...state,
        newAdvisor: payload,
      };
    case ADVISORS_REDUCER_TYPES.SET_ADVISORS_RETRIEVED_DATA:
      return {
        ...state,
        retrievedData: payload,
      };
    default:
      return state;
  }
};

const getAdvisorsData = (kit) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "get",
        url: `${SECTION}/${kit}/${ADVISORS_TABLE}`,
      });
      if (response?.status === 200 && response.data) {
        dispatch({
          type: ADVISORS_REDUCER_TYPES.GET_ADVISORS_DATA,
          payload: response.data.item,
        });
      }
      dispatch({
        type: ADVISORS_REDUCER_TYPES.SET_ADVISORS_RETRIEVED_DATA,
        payload: true,
      });
      dispatch(setLoading(false));
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoading(false));
      dispatch({
        type: ADVISORS_REDUCER_TYPES.SET_ADVISORS_RETRIEVED_DATA,
        payload: true,
      });
    }
  };
};

const getSelectedAdvisorData = (kit, id) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "get",
        url: `${LIST_ITEM}/${kit}/${ADVISORS_TABLE}/${id}`,
      });
      if (response?.status === 200 && response.data) {
        dispatch({
          type: ADVISORS_REDUCER_TYPES.GET_SELECTED_ADVISOR_DATA,
          payload: response.data.data,
        });
      }
      dispatch(setLoading(false));
      dispatch({
        type: ADVISORS_REDUCER_TYPES.SET_ADVISORS_RETRIEVED_DATA,
        payload: true,
      });
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const setAdvisorsData = (payload) => {
  const sortedPositions = payload.sort((a, b) => a.position - b.position);
  return async (dispatch) => {
    try {
      dispatch({
        type: ADVISORS_REDUCER_TYPES.SET_ADVISORS_DATA,
        payload: sortedPositions,
      });
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const setAdvisorsNewPositions = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: ADVISORS_REDUCER_TYPES.SET_ADVISORS_NEW_POSITIONS_DATA,
        payload,
      });
    } catch (error) {
      console.log(error);
    }
  };
};

const setSelectedAdvisorData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: ADVISORS_REDUCER_TYPES.SET_SELECTED_ADVISOR_DATA,
        payload,
      });
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const setNewAdvisorData = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: ADVISORS_REDUCER_TYPES.SET_NEW_ADVISOR_DATA,
        payload,
      });
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const saveChanges = (kit, newData) => {
  const data = [...newData];
  data.forEach(item => delete item.originalPosition);
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "post",
        url: SECTION,
        data: {
          kit,
          tableName: ADVISORS_TABLE,
          item: data,
        },
      });
      if (response?.status === 200) {
        dispatch({
          type: ADVISORS_REDUCER_TYPES.GET_ADVISORS_DATA,
          payload: response.data.item,
        });
        dispatch(setNotificationMessage('default_success'));
      }
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setNotificationMessage('default_error'));
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const saveSelectedAdvisorChanges = (kit, newData) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "put",
        url: LIST_ITEM,
        data: {
          kit,
          tableName: ADVISORS_TABLE,
          item: newData,
        },
      });
      if (response?.status === 200) {
        dispatch({
          type: ADVISORS_REDUCER_TYPES.GET_SELECTED_ADVISOR_DATA,
          payload: response.data,
        });
        dispatch(setNotificationMessage('default_success'));
      }
      dispatch({
        type: ADVISORS_REDUCER_TYPES.SET_ADVISORS_RETRIEVED_DATA,
        payload: false,
      });
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setNotificationMessage('default_error'));
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const saveNewAdvisor = (kit, newData) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "post",
        url: LIST_ITEM,
        data: {
          kit,
          tableName: ADVISORS_TABLE,
          item: newData,
        },
      });
      if (response?.status === 200) {
        dispatch({
          type: ADVISORS_REDUCER_TYPES.GET_ADVISORS_DATA,
          payload: response.data.item,
        });
        dispatch({
          type: ADVISORS_REDUCER_TYPES.SET_NEW_ADVISOR_DATA,
          payload: { ...NEW_ADVISOR },
        });
        dispatch(setCustomedNotificationMessage(`${newData.name} has been successfully added!`));
      }
      dispatch({
        type: ADVISORS_REDUCER_TYPES.SET_ADVISORS_RETRIEVED_DATA,
        payload: false,
      });
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setNotificationMessage('default_error'));
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

const deleteAdvisorData = (kit, id) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await axiosInstance({
        method: "delete",
        url: LIST_ITEM,
        data: {
          kit,
          tableName: ADVISORS_TABLE,
          id,
        },
      });
      if (response?.status === 200) {
        const { name } = response.data.deletedItem;
        dispatch(setCustomedNotificationMessage(`${name} has been successfuly removed!`));
        dispatch({
          type: ADVISORS_REDUCER_TYPES.GET_ADVISORS_DATA,
          payload: response.data.updatedList,
        });
      }
      dispatch(setLoading(false));
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
    }
  };
};

export const AdvisorsReducerActions = {
  getAdvisorsData,
  setAdvisorsData,
  getSelectedAdvisorData,
  setSelectedAdvisorData,
  setNewAdvisorData,
  saveChanges,
  saveSelectedAdvisorChanges,
  saveNewAdvisor,
  deleteAdvisorData,
  setAdvisorsNewPositions
};
